
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { Item, List, New } from './components'

export const ModuleRoutes = () => (
  <Layout>
    <List />
    <Routes>
      <Route path="new/*" element={<New />} />
      <Route path="booking/:id/*" element={<Item />} />
    </Routes>
  </Layout>
)
export default ModuleRoutes
